export enum ClientType {
    InteriorDesigner = 2,// مهندس ديكور
    Doctor = 3,//طبيب
    Pharmacist = 4,//صيدلى
    customer = 5// زبون عادي
}